import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=37923a44"
import script from "./ProductIntro.vue?vue&type=script&lang=js"
export * from "./ProductIntro.vue?vue&type=script&lang=js"
import style0 from "./ProductIntro.vue?vue&type=style&index=0&id=37923a44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports